import React from "react";
import { whyChooseUsData } from "../data/mock";
import { Shield, Sparkles, Clock, BadgeCheck } from "lucide-react";
import { Card } from "./ui/card";

const iconMap = {
  Shield,
  Sparkles,
  Clock,
  BadgeCheck,
};

const statsData = [
  { number: "20+", label: "Years Experience" },
  { number: "2000+", label: "Happy Customers" },
  { number: "7+", label: "Vehicles" },
  { number: "24/7", label: "Service Available" },
];

const WhyChooseSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      {/* Glow Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-amber-400/10 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-amber-500/20 text-amber-400 rounded-full text-sm font-semibold mb-4">
            WHY CHOOSE US
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            A Trusted Cab Service in Udaipur
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            BAHUBALI CABS is known for reliable service, professional drivers,
            and comfortable journeys across Rajasthan.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyChooseUsData.map((item, index) => {
            const IconComponent = iconMap[item.icon] || Shield;

            return (
              <Card
                key={item.id}
                className="group relative rounded-2xl overflow-hidden border border-white/10 shadow-xl hover:shadow-amber-500/20 transition-all duration-500 hover:-translate-y-2"
              >
                {/* BACKGROUND IMAGE */}
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{
                    backgroundImage: `url(${
                      item.backgroundImage || "/images/fallback.jpg"
                    })`,
                  }}
                />

                {/* DARK OVERLAY */}
                <div className="absolute inset-0 bg-black/60 group-hover:bg-black/50 transition-all duration-500" />

                {/* CONTENT */}
                <div className="relative z-10 p-6 text-center">
                  {/* Icon */}
                  <div className="w-16 h-16 mx-auto bg-gradient-to-br from-amber-400 to-amber-600 rounded-2xl flex items-center justify-center mb-5 shadow-lg group-hover:scale-110 transition">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>

                  <h3 className="text-lg font-bold text-white mb-3">
                    {item.title}
                  </h3>

                  <p className="text-white/80 text-sm leading-relaxed">
                    {item.description}
                  </p>

                  {/* Index Badge */}
                  <div className="absolute top-4 right-4 w-8 h-8 bg-white/10 rounded-full flex items-center justify-center">
                    <span className="text-amber-400 text-xs font-bold">
                      0{index + 1}
                    </span>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          {statsData.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-amber-400 to-amber-500 bg-clip-text text-transparent mb-2">
                {stat.number}
              </div>
              <div className="text-slate-400 text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
